<template>
  <div class="zxly">
    <div class="container">
      <cur-location :location="location" ></cur-location>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="title">{{location.xname}}</span>
          <p class="lytip"> 欢迎您的到来!您的每一条意见，我们都会认真对待。</p>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="您的姓名" style="display:none;" prop="name1">
            <el-input v-model="ruleForm.name1"></el-input>
          </el-form-item>
          <el-form-item label="留言内容" prop="content">
            <el-input  type="textarea" :rows="8" v-model="ruleForm.content"></el-input>
          </el-form-item>
           <el-form-item label="联系方式" prop="phone" style="margin-top: 50px;margin-bottom:50px;">
            <el-input  v-model="ruleForm.phone"></el-input>
          </el-form-item>
           <el-form-item label="称呼" prop="name">
            <el-input  v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item style="    text-align: center;">
            <el-button type="primary" @click="submitForm('ruleForm')" class="tijiao">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import CurLocation from "../components/PublicComs/CurLocation.vue";
import global from "@/components/PublicComs/Common.vue";
import {Message} from "element-ui"
export default {
  props: {
    plates: Array,
    webConfigs: Object,
  },
  components: { CurLocation },
  data() {
    return {
      location: {
        name: "交流",
        link: "",
        type: "info",
        xname:"在线留言"
      },
      global,
      isPhone:global.isPhone(),
      ruleForm: {
          name: '',
          content: '',
          phone: '',
          name1:""
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入留言内容', trigger: 'change' }
        ],
        phone: [
          {required: true, message: '请输入联系方式', trigger: 'change' }
        ]
      },
      
    };
  },

  created() {},

  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            ///
            this.$axios.post(`/api/leaveMessages`,this.ruleForm).then((res) => {
                  Message.success("提交成功");
                  this.ruleForm={
                      name: '',
                      content: '',
                      phone: ''
                  }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
  },
  beforeDestroy() {
    this.toTop();
  },
  computed: {},

  mounted() {
   let type = this.$route.query.type;
   switch (type) {
     case 'tsjy':
       this.location.xname = "投诉建议"
       break;
     case 'zxly':
       this.location.xname = "在线留言"
       break;
     case 'xfqd':
       this.location.xname = "信访渠道"
       break;
   }
  },

  watch: {
    
  },
};
</script>
<style scoped>
.zxly{
  background: url(/static/img/bg_liuyan.png);
  height:792px;
}
.box-card{
  width: 783px;
  height: 645px;
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(32, 58, 102, 0.17);
  margin:auto;
}
.title{
  font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;

}
.clearfix{
  text-align: center;
  margin-top:27px;
}
.lytip{
  font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #999999;
margin-top: 18px;
}
/deep/ .el-card__header{
  border-bottom:initial;
}
.tijiao{
      width: 297px;
    height: 54px;
    background: #306BCD;
    border-radius: 5px;
    text-align: center;
}
.demo-ruleForm{
      padding-right: 40px;
}
</style>
